import { Avatar, Badge } from '@change/ds-core-ui';
import { DecisionMakerIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

type AvatarAndBadgeProps = {
	photoUrl: string | null;
	displayName: string;
	showDMIcon?: boolean;
};

export const AvatarAndBadge: React.FC<AvatarAndBadgeProps> = ({ displayName, photoUrl, showDMIcon = false }) => {
	return (
		<div className={cn('relative flex justify-center', showDMIcon && 'mb-6')}>
			<Avatar src={photoUrl || undefined} alt={displayName} className="size-14 shrink-0 lg:size-20" />
			{showDMIcon && (
				<Badge
					data-testid="politician-badge"
					iconOnly
					leadingIcon={<DecisionMakerIcon size="large" />}
					size="medium"
					variant="information"
					emphasis="weaker"
					className="absolute bottom-[-20px] z-10 size-10 justify-center rounded-full border-4 border-white md:size-12"
				/>
			)}
		</div>
	);
};
